import React, { useState } from "react";
import styled from "styled-components";
import logo from "assets/logo/logo.png";
import { Link } from "react-router-dom";
import { MdDashboard } from "react-icons/md";
import { FiUsers } from "react-icons/fi";
import { IoIosStats, IoIosCodeWorking, IoIosSettings } from "react-icons/io";
import { BsToggleOn, BsToggleOff } from "react-icons/bs";
import { GiThorHammer } from "react-icons/gi";
import { GiHamburgerMenu } from "react-icons/gi";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { MdArrowDropDown } from "react-icons/md";
import { AuthContext } from "../context/Auth";

const BurgerButton = styled.span`
  position: relative;
  top: 30px;
  left: 10px;
  font-size: 20px;
  z-index: 1;
  visibility: hidden;
  border: 3px solid red;
  @media (max-width: 960px) {
    visibility: visible;
  }
`;

const SideBarFooter = styled.div`
  position: absolute;
  bottom: 0;
  background-color: #e4e9f1;
  width: 248px;
  height: 64px;
  padding: 1em 0;
  text-align: center;
  cursor: pointer;
  display: none;
  @media (max-width: 960px) {
    display: block;
  }
`;

const SideBarButton = styled.div`
    a {
      display: flex;
      text-align: center;
      align-items: center;
      margin: 0 0.5rem;
      font-size: 1rem;
      color: #fff;
      background-color: #27750a;
      border: none;
      width: 80%
      border-radius: 5px;
   }

   .options {
     marginLeft: 2rem
    position: relative;
    left: 10px;
    bottom: 5px;
    font-size: 35px;
    padding: 4px;
    :hover {
        border-radius: 30px;
        background-color: rgba(255, 255, 255, 0.2);
    }
}
`;

const Popover = styled.span`
  position: absolute;
  background-color: white;
  width: 89%;
  right: 15px;
  z-index: 1000;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

const SingleOption = styled.div`
  text-align: center;
  font-size: 18px;
  border-bottom: 1px solid #c4c4c4;
  padding-bottom: 0.7em;
  padding-top: 0.7rem;
  color: #333333;
  :hover {
    background-color: #eee;
    color: #27750a;
    cursor: pointer;
  }
`;

const Sidebar = () => {
  const [toggle, setToggle] = useState(false);
  const [isPopoverVisible, setIsPopoverVisible] = useState(false);
  const { logout, isAuthenticated } = React.useContext(AuthContext);

  // Removed window.addEventListener("resize") to prevent memory leaks

  const closeSideBar = () => {
    const sidebar = document.querySelector(".sidebar");
    const buttonToggle = document.querySelector(".burger");

    if (sidebar && buttonToggle) {
      sidebar.classList.add("close");
      sidebar.classList.remove("open");
      buttonToggle.style.visibility = "visible";
    }
  };

  const openSidebar = () => {
    const sidebar = document.querySelector(".sidebar");
    const buttonToggle = document.querySelector(".burger");

    if (sidebar && buttonToggle) {
      sidebar.classList.add("open");
      sidebar.classList.remove("close");
      buttonToggle.style.visibility = "hidden";
    }
  };

  const togglePopover = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setIsPopoverVisible(!isPopoverVisible);
  };

  const [activeOption, setActiveOption] = useState({
    text: "Cases",
    url: "/case",
  });

  const popoverOptions = [
    {
      text: "Cases",
      url: "/case",
    },
    {
      text: "Headnotes",
      url: "/headnotes",
    },
    {
      text: "Subject Matter",
      url: "/subject-matter",
    },
    {
      text: "Ratio Decidendi",
      url: "/ratio-decidendis",
    },
  ].filter((option) => option.text !== activeOption.text);

  const handleNotImplemented = (e) => {
    e.preventDefault();
    alert("This page is under development");
  };

  return (
    <React.Fragment>
      <aside className="sidebar">
        <header>
          <img src={logo} alt="logo" className="sidebar__logo" />
        </header>
        <nav className="sidebar-nav">
          <Link to="/app">
            <MdDashboard className="nav-icons" /> Dashboard{" "}
          </Link>
          <Link to="/" onClick={handleNotImplemented}>
            <FiUsers className="nav-icons" /> Manage Users{" "}
          </Link>
          <SideBarButton>
            <Link to={activeOption.url}>
              <IoIosStats className="nav-icons" /> {activeOption.text}{" "}
              <MdArrowDropDown onClick={togglePopover} className="options" />
            </Link>
            {isPopoverVisible && (
              <Popover className="popover">
                {popoverOptions.map((option) => (
                  <SingleOption
                    key={option.text}
                    onClick={() => {
                      setActiveOption(option);
                      setIsPopoverVisible(false);
                    }}
                  >
                    {option.text}
                  </SingleOption>
                ))}
              </Popover>
            )}
          </SideBarButton>
          <Link to="/" onClick={handleNotImplemented}>
            <GiThorHammer className="nav-icons" />
            Judgements{" "}
          </Link>
          <Link to="/justices">
            {" "}
            <GiThorHammer className="nav-icons" />
            Justices{" "}
          </Link>
          <Link to="/" onClick={handleNotImplemented}>
            <IoIosCodeWorking className="nav-icons" />
            Activities{" "}
          </Link>
          <Link to="/" onClick={handleNotImplemented}>
            <IoIosSettings className="nav-icons" />
            Settings{" "}
          </Link>
          <Link
            to="/"
            onClick={(e) => {
              e.preventDefault();
              setToggle(true);
              setTimeout(() => {
                if (logout) {
                  logout({ variables: { type: "" } });
                }
              }, 600);
            }}
          >
            {isAuthenticated && !toggle ? (
              <BsToggleOff className="nav-icons" />
            ) : (
              <BsToggleOn className="nav-icons" />
            )}{" "}
            Log out
          </Link>
        </nav>
        <SideBarFooter onClick={closeSideBar}>
          <MdKeyboardArrowLeft size={24} />
        </SideBarFooter>
      </aside>
      <BurgerButton className="burger" onClick={openSidebar}>
        <GiHamburgerMenu />
      </BurgerButton>
    </React.Fragment>
  );
};

export default Sidebar;
